import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Dictinary } from "@app/shared/models";
import { environment } from "@env/environment";
import { map, Observable } from "rxjs";

interface AgesData {
  id: number;
  title: string;
}

@Injectable({
  providedIn: "root",
})
export class AgesService {
  constructor(private http: HttpClient) {}

  loadAges(): Observable<Dictinary[]> {
    return this.http
      .get<{ data: AgesData[] }>(`${environment.primaryApiUrl}/tags/ages`)
      .pipe(
        map((data) => data.data),
        map((data) =>
          data.map((item) => ({
            id: item.id,
            name: item.title,
          })),
        ),
      );
  }
}
